import { useEffect, useState } from 'react';
import { Bars } from 'react-loader-spinner';
import { ToggleWithLabel } from '../ToggleWithLabel';
import { MainCustomButton } from '../../../../../components/Buttons';
import { useTranslation } from 'react-i18next';
import { JurisdictionSelect } from '../JurisdictionSelect';
import { useFees } from '../../../../../hooks/useFees';
import { errorToast } from '../../../../../utils/toasts';
import { NumberFormatBase } from 'react-number-format';

type EditableFee = {
  fee_id: number;
  label: string;
  value: number;
  active: boolean;
};


const FeesTab = () => {
  const { t } = useTranslation();
  const { fees, loading, updateFee } = useFees();
  const [editableFees, setEditableFees] = useState<EditableFee[]>([]);
  const [selectedJurisdictionId, setSelectedJurisdictionId] = useState<number | null>(null);

  useEffect(() => {
    console.log('fees: ', fees);

    if (fees && fees.length > 0 && selectedJurisdictionId !== null) {
      const adapted: EditableFee[] = fees
        .filter((fee) => fee.jurisdiction_id === selectedJurisdictionId)
        .map((fee) => ({
          fee_id: Number(fee.fee_id),
          label: fee.fee_description,
          value: Number(fee.value),
          active: fee.is_active === 1,
        }));
      setEditableFees(adapted);
    }
  }, [fees, selectedJurisdictionId]);

  const toggleFee = (fee_id: number) => {
    setEditableFees(prev =>
      prev.map(f => (f.fee_id === fee_id ? { ...f, active: !f.active } : f))
    );
  };

  const updateFeeValue = (fee_id: number, newValue: string) => {
    const parsedValue = parseFloat(newValue);
    setEditableFees(prev =>
      prev.map(f => (f.fee_id === fee_id ? { ...f, value: parsedValue } : f))
    );
  };

  const handleSave = async () => {
    try {
      await Promise.all(
        editableFees.map(fee =>
          updateFee({
            fee_id: fee.fee_id,
            value: Number(fee.value),
            is_active: fee.active ? 1 : 0,
          })
        )
      );
    } catch (error) {
      errorToast(t('environment.errorSavingFees'));
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center py-6">
        <Bars height="32" width="32" color="#4B5563" />
      </div>
    );

  return (
    <div className="flex flex-col gap-4">
      {/* Jurisdiction select */}
      <JurisdictionSelect
        selectedJurisdictionId={selectedJurisdictionId}
        setSelectedJurisdictionId={setSelectedJurisdictionId}
      />

      {/* Fee list */}
      <div className="flex flex-col gap-4">
        {editableFees.map((fee) => (
          <div
            key={fee.fee_id}
            className="border border-dashed p-4 rounded flex items-center justify-between"
          >
            <div className="flex flex-col">
              <label className="text-sm">{fee.label}:</label>
              {/* <input
                type="text"
                value={fee.value}
                onChange={(e) => updateFeeValue(fee.fee_id, e.target.value)}
                className="mt-1 border rounded px-3 py-1 w-40"
              /> */}
              <div className="relative mt-1 w-40">
                <span className="absolute left-3 inset-y-0 flex items-center pointer-events-none">$</span>
                <input
                  type="text"
                  value={fee.value}
                  onChange={(e) => updateFeeValue(fee.fee_id, e.target.value)}
                  className="pl-7 pr-2 py-1.5 border rounded w-full"
                />
              </div>
            </div>

            <ToggleWithLabel
              checked={fee.active}
              onChange={() => toggleFee(fee.fee_id)}
            />
          </div>
        ))}
      </div>

      {/* Save button */}
      <MainCustomButton text={t('others.othSave')} onClick={handleSave} />
    </div>
  );
};

export { FeesTab };
